import { UntypedFormGroup } from '@angular/forms';
import { FieldConfigDTO } from '../../../system/system-dtos';
import { isDefined, isObject } from '../../utils/utils';

export class DataTypeComponent {
  fieldConfig: FieldConfigDTO;

  data: any;

  editMode = false;

  formGroup: UntypedFormGroup;

  clipboardCopied = false;

  showClipboard = false;

  hasFilters = false;

  initialise() {
    this.showClipboard = this.canShowClipboard(this.fieldConfig);
  }

  setRowData(entity: any) {}

  copyToClipboard() {
    this.clipboardCopied = true;
    this.copyDataToClipboard(this.data);
  }

  canShowClipboard(fieldConfig: FieldConfigDTO): boolean {
    if (isDefined(fieldConfig) && isDefined(fieldConfig.clipboard) && this.fieldConfig.clipboard) {
      return true;
    }
    if (isDefined(fieldConfig) && isDefined(fieldConfig.name)) {
      if (fieldConfig.name.toLowerCase().endsWith('id')) {
        return true;
      }
    }
    return false;
  }

  copyDataToClipboard(data: any) {
    if (isDefined(data)) {
      const el: any = document.createElement('textarea');
      if (isObject(data)) {
        el.value = JSON.stringify(this.data);
      } else {
        el.value = this.data;
      }
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  }
}

export enum DataType {
  tree = 'tree',
  graph = 'graph',
  avatar = 'avatar',
  booster = 'booster',
  card_panel = 'card_panel',
  changes = 'changes',
  checkbox = 'checkbox',
  color = 'color',
  condition = 'condition',
  count = 'count',
  codepen = 'codepen',
  date_range = 'date_range',
  date_time = 'date_time',
  date = 'date',
  diamond_panel = 'diamond_panel',
  deeplink = 'deeplink',
  bundle = 'bundle',
  draw_options = 'draw_options',
  emoji = 'emoji',
  future_draws = 'future_draws',
  header = 'header',
  html = 'html',
  html_block = 'html_block',
  file_upload = 'file_upload',
  image_uploader = 'image_uploader',
  image = 'image',
  link = 'link',
  dynamic_link = 'dynamic_link',
  logo = 'logo',
  lookup = 'lookup',
  paged_lookup = 'paged_lookup',
  lotto_line = 'lotto_line',
  map = 'map',
  money = 'money',
  moneyline = 'moneyline',
  markets = 'markets',
  betslip = 'betslip',
  multi_option = 'multi_option',
  multiple = 'multiple',
  nested_table = 'nested_table',
  number = 'number',
  odds = 'odds',
  offer = 'offer',
  option = 'option',
  option_panel = 'option_panel',
  payment = 'payment',
  player_status = 'player_status',
  prize_table = 'prize_table',
  properties = 'properties',
  quick_picks = 'quick_picks',
  radio = 'radio',
  rate = 'rate',
  report = 'report',
  rewards = 'rewards',
  spending_limit = 'spending_limit',
  sub_panel = 'sub_panel',
  hero_slides = 'hero_slides',
  hero_slide = 'hero_slide',
  rule = 'rule',
  symbol = 'symbol',
  slide = 'slide',
  slide_deck = 'slide_deck',
  text = 'text',
  textarea = 'textarea',
  time = 'time',
  todo = 'todo',
  toggle = 'toggle',
  weekdays = 'weekdays',
  rearranging_list = 'rearranging_list',
  code = 'code',
  adyen_ref = 'adyen_ref',
  shape = 'shape',
  chart = 'chart',
  open_in_player = 'open_in_player',
  video = 'video',
  iframe = 'iframe',
  metric = 'metric',
  multi_lookup = 'multi_lookup',
  new_money = 'new_money',
  wysihtml = 'wysihtml',
  site_tree = 'site_tree',
  player_info = 'player_info',
  smart_filter = 'smart_filter',
  duration = 'duration',
  star = 'star',
  entity_restriction_checkbox = 'entity_restriction_checkbox',
  availability_summary = 'availability_summary',
  stopwatch = 'stopwatch',
  criteria = 'criteria',
  deposits_in_24h_threshold_override = 'deposits_in_24h_threshold_override',
  daily_deposit_limit_override = 'daily_deposit_limit_override', // old, to be removed
  personal_lifetime_net_loss_thresholds = 'personal_lifetime_net_loss_thresholds',
  personal_monthly_net_loss_thresholds = 'personal_monthly_net_loss_thresholds',
  personal_lifetime_deposits_thresholds = 'personal_lifetime_deposits_thresholds',
  lifetime_net_loss_thresholds_settings = 'lifetime_net_loss_thresholds_settings',
  lifetime_deposit_thresholds_settings = 'lifetime_deposit_thresholds_settings',
  affordability_settings = 'affordability_settings',
  net_losses = 'net_losses',
  promotion_exclude = 'promotion_exclude',
  player_consents = 'player_consents',
  promo_claim_rate = 'promo_claim_rate',
  player_restrictions = 'player_restrictions',
  responsible_gaming_config = 'responsible_gaming_config',
}
